export default __webpack_public_path__ + "static/media/proclamation6.e3843273.jpg";